var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1090,
    height: 818,
    viewBox: "0 0 1090 818",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_595_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M735.983 -137.017C724.418 -148.582 707.926 -153.76 691.825 -150.881L83.8357 -42.1466C73.7759 -40.3474 64.509 -35.509 57.2828 -28.2828L-244.645 273.645C-264.171 293.171 -264.171 324.829 -244.645 344.355L-55.9912 533.009C-44.4212 544.579 -27.922 549.756 -11.8161 546.869L596.462 437.862C606.515 436.061 615.776 431.224 622.998 424.002L924.644 122.355C944.171 102.829 944.171 71.1707 924.644 51.6445L735.983 -137.017Z",
    fill: "url(#paint0_linear_595_3312)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_595_3312",
    x: -409.289,
    y: -301.662,
    width: 1498.58,
    height: 999.316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_595_3312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_595_3312",
    x1: -279.932,
    y1: 308.807,
    x2: 883.186,
    y2: 516.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9708CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43CBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6660391a2f7c407e76af51e109370f8c.svg";
export { ForwardRef as ReactComponent };